// The TSP coverage map's base map and boundary data — the ONLY place that names
// a tile provider, so it can be swapped without touching any map logic.
//
// Base map: OpenFreeMap "Liberty" (OpenStreetMap data, OpenMapTiles schema).
// Free, no API key, commercial use allowed, no request limits, no SLA
// (https://openfreemap.org). Attribution ("OpenFreeMap © OpenMapTiles Data from
// OpenStreetMap") comes with the style and is shown by MapLibre automatically.
// Any MapLibre style URL on the OpenMapTiles schema can replace it through
// REACT_APP_TSP_MAP_STYLE_URL (e.g. a self-hosted OpenFreeMap / tileserver).
//
// State boundaries: Survey of India (see public/tsp/geo/README.md). They are an
// outline to see and click — never a source of any marker position.
export const TSP_MAP_CONFIG = Object.freeze({
  styleUrl: process.env.REACT_APP_TSP_MAP_STYLE_URL || "https://tiles.openfreemap.org/styles/liberty",
  statesUrl: `${process.env.PUBLIC_URL || ""}/tsp/geo/india-states-soi.geojson`,
  nationalBoundaryUrl: `${process.env.PUBLIC_URL || ""}/tsp/geo/india-boundary-soi.geojson`,
  statesAttribution: "Boundaries © Survey of India",
  // The map shows India only: this plain colour covers everything outside
  // India's Survey of India boundary (other countries and the sea).
  outsideIndiaColor: "#eef2f9",
  // The base style's own boundary lines are hidden — country (boundary_2),
  // sub-national (boundary_3) and disputed (boundary_disputed). OpenStreetMap
  // draws India's northern border as actually controlled, and its tiles carry
  // no country names on border lines to hide only India's. India's national
  // boundary and its states are drawn from the Survey of India data instead
  // (so borders between two OTHER countries are not drawn).
  hiddenStyleLayers: ["boundary_2", "boundary_3", "boundary_disputed"],
  // The base style's country-name labels ("India / भारत" over the middle of
  // the map). Only India's own name is left out — the map is of India — so
  // neighbouring countries keep their names when zoomed in.
  hiddenCountryLabel: { layers: ["label_country_1", "label_country_2", "label_country_3"], iso: "IN", name: "India" },
  // The whole country (Survey of India extent, incl. Ladakh and the islands) in view.
  india: { center: [82.8, 22.2], zoom: 3.7, bounds: [[67.9, 6.5], [97.5, 37.2]] }, // [lng, lat]
  cityZoom: 11,
  stateMaxZoom: 9,
  // A point picked while zoomed out further than this is only roughly placed:
  // the map zooms in to it (to this zoom) so the person can refine it.
  pickRefineZoom: 10,
});
